import React from "react"
import "./index.scss"
import LazyImage from "../../components/LazyImage"

const CaseProjectBlock = ({
    client = false,
    title,
    text,
    image,
}) => {
    return (
        <div className="case-project-block-wrapper">
            <h3 className="t-h3 desk">
                {client ? "THE CLIENT" : "THE PROJECT"}
            </h3>
            <div className="case-project-block">
                <h3 className="t-s3 mob">
                    {client ? "THE CLIENT" : "The Project"}
                </h3>
                {image && <LazyImage src={image} alt="project image"/>}
                <h4 className="t-s3">{title}</h4>
                <div className="t-b3 case-project-block-text">
                    {text.map((el, id) => (
                        <p key={id}>{el}</p>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CaseProjectBlock
